import { AuthState } from '@okta/okta-auth-js';

import { Locations } from '../../services/backend/Locations';
import { useBaseApiClient } from '../useBaseApiClient';

export const useLocations: () => Locations<AuthState> = () => {
  return useBaseApiClient(Locations);
};
